import './CourseDrawer.scss'
import Author from 'components/practices/Author/Author'

export default function CourseDrawer({ authors }) {
  return (
    <div className='course-drawer-container'>
      <h2 className='mb-4'>About the author{authors?.length > 1 && 's'}</h2>
      {authors?.map(author => (
        <Author key={author.id} author={author} />
      ))}
    </div>
  )
}
